import Box from '@mui/material/Box';
import Button from 'common/components/Elements/Button/Button';
import ButtonLoading from 'common/components/Elements/ButtonLoading/ButtonLoading';
import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import { deleteCommand } from 'core/redux/actions/command/commandActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandDelete({ command, small }: ComponentProps) {
  const {
    id, title, active, shortcut, action, label,
  } = command;
  const ref = React.createRef<HTMLButtonElement>();
  const persistingCommand = useSelector((state: ApplicationState) => state.page.persistingCommand);
  const persisting = persistingCommand && persistingCommand.id === id;

  const dispatch = useDispatch<AppThunkDispatch>();

  const shortcutTrigger = useShortcut(...(shortcut || []));

  useEffect(() => {
    if (active && shortcut && shortcutTrigger && ref && ref.current) {
      ref.current.click();
    }
  }, [shortcut, shortcutTrigger, active, command, ref]);

  return (
    <Box position="relative" display="inline-block">
      <Button
        // default in the Confirmer is warning, in this case we want deleteWarning instead
        action={(action !== 'warning' ? action : undefined) || 'deleteWarning'}
        className={classes.command}
        title={title}
        onClick={() => dispatch(deleteCommand(command))}
        small={small}
        disabled={active === false || persisting}
        e2eId={id}
        buttonRef={ref}
        buttonIcon={label === undefined}
      >
        <CommandLinkContent command={command} />
      </Button>
      {persisting && (
        <ButtonLoading />
      )}
    </Box>
  );
}

export default CommandDelete;
